import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { reactLocalStorage } from "reactjs-localstorage";

import { apiKeyHeader } from "../../../configs/ApiKeys";

import AllFeatureDataTable from "../../../GuiComponents/AllFeatureDataTable.table";
import {
  WSDeleteItemProductForCosting,
  WsGetCostSheets,
} from "../../../configs/WebService";
import userStore from "../../../zustand/userStore";
import Popup from "../Popup";
import EventActivity from "./EventActivity";
import { updateCostSheetStatus } from "../redux/eventOrganiserThunks";
import { useDispatch } from "react-redux";
import { setCostSheet } from "../redux/eventOrganiserSlice";

const ShowAllIPC = () => {
  // const orgId = 1; //Testing
  // const userId = 1; //Testing
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // const userData = reactLocalStorage.getObject("cs_user_data");
  const userData = userStore((state) => state.user);
  const [open, isOpen] = useState(false);
  const [selectedData, isSelectedData] = useState({});
  const [errorMsg, setErrorMsg] = useState("");

  console.log("selectedData", selectedData);

  const dataTableColumns = [
    {
      Header: "#",
      accessor: "sno",
    },
    {
      Header: "Event Name",
      accessor: "event_name",
    },
    {
      Header: "Activity Name",
      accessor: "activity",
    },
    {
      Header: "Title",
      accessor: "title",
    },
    {
      Header: "Detail",
      accessor: "detail",
    },
    {
      Header: "Action(s)",
      accessor: "actiontd",
    },
  ];

  const [dataTableDatas, setDataTableDatas] = useState([]);

  useEffect(() => {
    fetchProductForCosting();
  }, []);

  function fetchProductForCosting() {
    axios
      .get(WsGetCostSheets + "/" + userData.id, {
        headers: apiKeyHeader(),
      })
      .then((response) => {
        const responseData = response.data;
        console.log("responseData", responseData);
        if (responseData.resultCode == 1) {
          setDataTableDatas(set2DataTableDatas(responseData.resultMessage));
          setErrorMsg("");
        } else {
          setErrorMsg(responseData.resultMessage);
        }
      })
      .catch((error) => {
        //console.log("", "error " + error);
        setErrorMsg("Error whilte getting data");
      });
  }

  function goToCostingSheetCalculation(costingSheet) {
    delete costingSheet["actiontd"]; //Bug(If Not Using): Point To Be Notted
    navigate("/costingSheetCalculationProcess", {
      state: { costingSheet: costingSheet },
    });
  }

  let masterItem = {
    title: "BOQ",
    code: "boq_bom",
    price: 0,
  };
  function goToAddCostingSheetItems(costingSheet) {
    console.log("costingSheet", costingSheet);
    // return;
    delete costingSheet["actiontd"]; //Bug(If Not Using): Point To Be Notted
    // navigate("/costingMasters", {
    //   state: { costingSheet: costingSheet },
    // });
    navigate("/costingAddItems", {
      state: {
        masterItem: masterItem,
        costingSheet: { ...costingSheet, cost_sheet_id: costingSheet.id },
        type: "forMasterItem",
      },
    });
  }

  function editAlert(costingSheet) {
    if (window.confirm("Sure to edit")) {
      delete costingSheet["actiontd"]; //Bug(If Not Using): Point To Be Notted
      navigate("/addipcosting", {
        state: { costingSheet: costingSheet },
      });
    }
  }

  function delAlert(costingSheet, dataArray) {
    if (window.confirm("Sure to delete")) {
      proceedToDelete(costingSheet, dataArray);
    }
  }

  function proceedToDelete(costingSheet2Delete, dataArray) {
    // console.log("proceedToDelete_costingSheet2Delete",costingSheet2Delete);

    let formJsonParams = JSON.stringify({
      userId: userData.id,
      productForCostingId: costingSheet2Delete.id,
    });

    axios
      .post(WSDeleteItemProductForCosting, formJsonParams, {
        headers: apiKeyHeader(),
      })
      .then((response) => {
        const responseData = response.data;
        // console.log("responseData", responseData);
        if (responseData.result_code == 1) {
          var tempDataTables = dataArray.filter(function (csData) {
            // console.log("proceedToDelete_csData",csData);
            return costingSheet2Delete.id !== csData.id;
          });
          // console.log("proceedToDelete_tempDataTables",tempDataTables);
          setDataTableDatas(set2DataTableDatas(tempDataTables));
        } else {
          alert(responseData.result_message);
        }
      })
      .catch((error) => {
        alert("Error whilte getting data");
      });
  }
  const handleStatusChange = async (simpleData, status) => {
    console.log("simpleData", simpleData, status);
    const resultAction = await dispatch(
      updateCostSheetStatus({
        id: simpleData.id,
        status,
        // orgId: userData.org.id,
        userId: userData.id,
      })
    );

    if (updateCostSheetStatus.fulfilled.match(resultAction)) {
      window.location.reload();
    }
  };

  function set2DataTableDatas(simpleDataArray) {
    let blankData = [];
    simpleDataArray.map((simpleData, index) => {
      simpleData["sno"] = index + 1;
      simpleData["event_name"] = simpleData.other_details[0].event_name || "NA";
      simpleData["activity"] =
        simpleData.other_details[0].activity_name || "NA";
      simpleData["actiontd"] = (
        <div className="cost-sheet-actions" style={{ display: "flex", alignItems: "center", gap: "6px", flexWrap: "nowrap" }}>
          <i
            className="fa fa-eye"
            style={{ color: "#007bff", cursor: "pointer", fontSize: "1rem" }}
            aria-hidden="true"
            title="View"
            onClick={() => goToAddCostingSheetItems(simpleData)}
          ></i>
          <i
            className="fa fa-pencil"
            style={{ color: "#333", cursor: "pointer", fontSize: "1rem" }}
            onClick={() => editAlert(simpleData)}
            aria-hidden="true"
            title="Edit"
          ></i>
          {simpleData?.other_details?.[0]?.activity_id == null && (
            <i
              className="fa fa-link"
              style={{ color: "#6c757d", cursor: "pointer", fontSize: "1rem" }}
              title="Link"
              onClick={() => {
                isOpen(true);
                isSelectedData(simpleData);
              }}
            ></i>
          )}
          {simpleData?.cst_status === "0" && (
            <button
              className="cost-sheet-approve-btn"
              style={{
                background: "#389f4f",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                padding: "2px 8px",
                cursor: "pointer",
                fontSize: "0.9rem",
                fontWeight: "500",
                boxShadow: "0 2px 6px rgba(40, 167, 69, 0.3)",
                transition: "transform 0.2s, box-shadow 0.2s",
                whiteSpace: "nowrap",
              }}
              onClick={() => handleStatusChange(simpleData, "1")}
            >
              Approve
            </button>
          )}
          {simpleData?.cst_status === "1" && (
            <button
              className="cost-sheet-reject-btn"
              style={{
                background: "linear-gradient(135deg, #dc3545 0%, #c82333 100%)",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                padding: "5px 12px",
                cursor: "pointer",
                fontSize: "0.8rem",
                fontWeight: "500",
                boxShadow: "0 2px 6px rgba(220, 53, 69, 0.3)",
                transition: "transform 0.2s, box-shadow 0.2s",
                whiteSpace: "nowrap",
              }}
              onClick={() => handleStatusChange(simpleData, "0")}
            >
              Reject
            </button>
          )}
        </div>
      );
      blankData.push(simpleData);
    });

    return blankData;
  }

  return (
    <>
      {/* <ReactTooltip place="top" type="dark" effect="solid" /> */}
      {errorMsg ? (
        <div>
          <b>{errorMsg}</b>
        </div>
      ) : null}
      {(() => {
        if (errorMsg.length <= 0) {
          return (
            <div className="table-responsive">
              {open && (
                <Popup
                  title="Link your costsheet with Event And Activity"
                  minHeight="400px"
                  maxWidth="800px"
                  jsustifyContent="center"
                  onClose={() => isOpen(false)}
                >
                  <EventActivity
                    isOpen={isOpen}
                    data={selectedData}
                    setDataTableDatas={setDataTableDatas}
                  />
                </Popup>
              )}
              <AllFeatureDataTable
                columns={dataTableColumns}
                data={dataTableDatas}
              />
            </div>
          );
        }
      })()}
    </>
  );
};
export default ShowAllIPC;
